import { Component, OnInit, Input } from '@angular/core';
import { MemberActivity } from '../shared/model/member-activity.model';
import { MemberService } from 'src/app/member/shared/member.service';
import { MemberActivityTypeModel } from 'src/app/member/shared/member-activity-type.model';

@Component({
  selector: 'wl-profile-member-activity-editing',
  templateUrl: './profile-member-activity-editing.component.html',
  styleUrls: ['./profile-member-activity-editing.component.less'],
    standalone: false
})
export class ProfileMemberActivityEditingComponent implements OnInit {
  @Input() memberActivity: MemberActivity;
  @Input() isReadOnly: boolean 
  public activityTypes: Array<MemberActivityTypeModel>;

  constructor(private _memberService: MemberService) {
    this.memberActivity = new MemberActivity();
  }

  async ngOnInit() {
    this.activityTypes = (await this._memberService.getMemberActivityTypes())
      .sort((x, y) => {
        if (x.ActivityType < y.ActivityType) {
          return -1;
        } else if (x.ActivityType > y.ActivityType) {
          return 1;
        } else {
          return 0;
        }
      });
  }

  public activitySelected(activityType: number) {
    this.memberActivity.ActivityType = this.activityTypes.find(x => x.ActivityTypeID == activityType).ActivityType;
  }
}
